export class ConnectionSearch {
        model_type: string;
        filters:any=[];
        
}
